import type { Auth0Error } from "./types";
import useMFAToken from "./useMFAToken";

export default function useAuthenticator() {
  const { getAccessToken } = useMFAToken();
  const auth0URL = `https://${process.env.REACT_APP_AUTH0_ORIGINAL_DOMAIN}`;

  const getAuthenticators = async () => {
    const token = await getAccessToken("read:authenticators");
    const url = `${auth0URL}/mfa/authenticators`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return await response.json();
  };

  const deleteAuthenticator = async (id: string) => {
    const token = await getAccessToken("remove:authenticators");
    const url = `${auth0URL}/mfa/authenticators/${id}`;

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  };

  const deleteInActiveAuthenticators = async () => {
    let status = 204;
    let errors: Auth0Error[] = [];

    const token = await getAccessToken("remove:authenticators");

    const authenticators = await getAuthenticators();

    for await (const authenticator of authenticators) {
      const { id, active } = authenticator;
      if (!active) {
        const url = `${auth0URL}/mfa/authenticators/${id}`;
        const res = await fetch(url, {
          method: "DELETE",
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status !== 204) {
          status = res.status;
          const { error, error_description } = await res.json();
          errors.push({
            error,
            error_description,
          });
        }
      }
    }

    return {
      status,
      errors,
    };
  };

  return {
    getAuthenticators,
    deleteAuthenticator,
    deleteInActiveAuthenticators,
  };
}
